export const isPresent = value => value && (value.trim().length > 0);
